interface Route<T> {
  INTEGRATIONS: {
    SymantecEDR: {
      [key: string]: T
    },
  },
}

const SymantecEDRRoutes: Route<{ index: string }> = {
  INTEGRATIONS: {
    SymantecEDR: {
      ACTIVITYAPI: {
        index: '/integrations/symantecedr',
      },
    },
  },
};

const ApiRoutes: Route<string> = {
  INTEGRATIONS: {
    SymantecEDR: {
      SAVE_INPUT: '/plugins/org.graylog.enterprise.integrations/symantecedr/inputs',
      CHECK_CREDENTIALS: '/plugins/org.graylog.enterprise.integrations/symantecedr/checkCredentials',

    },
  },
};

const DocsRoutes: Route<string> = {
  INTEGRATIONS: {
    SymantecEDR: {
      GRAYLOG_SymantecEDR_ACTIVITY_LOG_INPUT: 'integrations/inputs/graylog_symantecEDR_ActivityLog_Input.html#graylog-symantecEDR-activitylog-input',
    },
  },
};

export default SymantecEDRRoutes;

export { DocsRoutes, ApiRoutes };
